import React, { ChangeEvent, useEffect, useState } from 'react';
import {
  Card,
  Grid,
  Tooltip,
  Checkbox,
  FormControlLabel,
  FormGroup,
} from '@material-ui/core';
import { isEmpty, uniqueId, get, isNil } from 'lodash';
import { IntlShape, injectIntl } from 'react-intl';
import messages from 'containers/AttributionManager/messages';
import { translate } from 'containers/services/translate';
import { StyledTitleRoles } from 'containers/AttributionManager/styles';

import {
  StyledCard,
  StyledSpan,
  StyledToolTip,
  StyledSpacingGrid,
  StyledSpacing,
} from 'containers/AttributionManager/styles';
import {
  extractInboxesByUserId,
  constructTitleOfInboxes,
} from 'containers/AttributionManager/utils';
import ConfirmationUnassignedManagerDialog from 'containers/AttributionManager/Dialogs/ConfirmationUnassignedManagerDialog';
import currentUserStorage from 'containers/services/security/current-user-storage';

export interface UnassignedManagerProps {
  intl: IntlShape;
  List: any;
  isSelectedManagers: boolean;
  usersInboxes: any;
  handleCloseUnassignedManagerConfirmationDialog: Function;
  openUnassignedManagerConfirmationDialog: boolean;
  handleValidateDialog: Function;
  selectedInboxe: any;
  setSelectAllUnassignedManagers: Function;
  selectAllUnassignedManagers: boolean;
  selectedArea?: any;
  listings: any;
}

export const UnassignedManager: React.FC<UnassignedManagerProps> = (
  props,
): JSX.Element => {
  const [associatedManagers, setAssociatedManagers] = useState<any>([]);
  useEffect(() => {
    if (!props.selectAllUnassignedManagers) {
      setAssociatedManagers([]);
    } else if (isEmpty(associatedManagers)) {
      setAssociatedManagers(props.List.map((el: any) => el?.id));
    }
  }, [props.selectAllUnassignedManagers]);
  const isChecked = (id: number) => {
    return associatedManagers.includes(id);
  };

  const handleCheckManagers = (
    event: ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => {
    let newAssociatedManagers = [...associatedManagers];
    const newValue = parseInt(event.target.value);
    if (!associatedManagers.includes(newValue)) {
      newAssociatedManagers = [...associatedManagers, newValue];
    } else {
      newAssociatedManagers.splice(associatedManagers.indexOf(newValue), 1);
    }
    setAssociatedManagers(newAssociatedManagers);
    props.setSelectAllUnassignedManagers(true);
  };

  const handleValidate = () => {
    let formattedPayload;
    const assignedManagersIds = props.List.filter((el: any) =>
      isChecked(el?.id),
    );
    if (
      !isEmpty(get(props.listings, 'transactionInboxeArea', [])) &&
      !isNil(props.selectedArea)
    ) {
      const transactionInboxeAreaId = get(
        get(props.listings, 'transactionInboxeArea', []).find(
          (el: any) =>
            el.managerInboxesId === props.selectedInboxe &&
            el.transactionAreaId === props.selectedArea,
        ),
        'id',
      );
      formattedPayload = assignedManagersIds.map((el: any) => ({
        userPrivilegesId: el.id,
        managerInboxesId: props.selectedInboxe,
        transactionInboxeAreaId: transactionInboxeAreaId,
        createdBy: currentUserStorage.get()?.username,
      }));
    } else {
      formattedPayload = assignedManagersIds.map((el: any) => ({
        userPrivilegesId: el.id,
        managerInboxesId: props.selectedInboxe,
        createdBy: currentUserStorage.get()?.username,
      }));
    }

    props.handleValidateDialog({
      managerAssignementInboxes: formattedPayload,
    });
    props.handleCloseUnassignedManagerConfirmationDialog();
    props.setSelectAllUnassignedManagers(false);
  };

  const renderItem = (item: any) => {
    return (
      <Grid item>
        <Card style={StyledCard} elevation={0}>
          <Grid
            container
            direction="row"
            spacing={0}
            justify="space-between"
            style={{ flexWrap: 'nowrap' }}
          >
            <Grid item>
              <Grid
                container
                direction="row"
                alignItems="center"
                style={{ flexWrap: 'nowrap' }}
              >
                <Grid item>
                  <FormGroup key={uniqueId()}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isChecked(item.id)}
                          color="primary"
                          value={item.id}
                          onChange={handleCheckManagers}
                          style={{ marginTop: '-3px', padding: 3 }}
                        />
                      }
                      label={''}
                    />
                  </FormGroup>
                </Grid>

                <Grid
                  item
                  style={
                    props.isSelectedManagers ? StyledSpacingGrid : StyledSpacing
                  }
                >
                  <span style={StyledSpan}>{item?.sagisName}</span>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <Tooltip
                title={
                  translate(messages.assignedTasksTitle, props) +
                  ': ' +
                  constructTitleOfInboxes(
                    extractInboxesByUserId(props.usersInboxes, item.id),
                  )
                }
                aria-label="add"
              >
                <div style={StyledToolTip}>
                  {extractInboxesByUserId(props.usersInboxes, item.id)?.length}
                </div>
              </Tooltip>
            </Grid>
          </Grid>
        </Card>
      </Grid>
    );
  };
  const OpeningManager = props.List.filter(
    (el: any) => el?.dataValues?.isOpeningManager,
  );
  const CourtManager = props.List.filter(
    (el: any) => el?.dataValues?.isCourtManager,
  );
  const CourtMonitoringManager = props.List.filter(
    (el: any) => el?.dataValues?.isCourtMonitoringManager,
  );
  const preOpeningManager = props.List.filter(
    (el: any) => el?.dataValues?.isPreOpenManager,
  );
  const solhFelHinManager = props.List.filter(
    (el: any) => el?.dataValues?.isSolhFlhin,
  );
  const transactionManager = props.List.filter(
    (el: any) => el?.dataValues?.isTransactionManager,
  );
  const isPriorityClaimManager = props.List.filter(
    (el: any) => el?.dataValues?.isPriorityClaimsManager,
  );
  const otherManagers = props.List.filter(
    (el: any) =>
      !el?.dataValues?.isOpeningManager &&
      !el?.dataValues?.isCourtManager &&
      !el?.dataValues?.isCourtMonitoringManager &&
      !el?.dataValues?.isPreOpenManager &&
      !el?.dataValues?.isSolhFlhin &&
      !el?.dataValues?.isTransactionManager &&
      !el?.dataValues?.isPriorityClaimsManager,
  );
  return (
    <>
      {!isEmpty(OpeningManager) && (
        <>
          <div style={{ marginBottom: 10, marginTop: 12 }}>
            <span style={StyledTitleRoles}>
              {translate(messages.openingManager, props)}
            </span>
          </div>
          <Grid container direction="row" spacing={2}>
            {OpeningManager.map((item: any) => renderItem(item))}
          </Grid>
        </>
      )}

      {!isEmpty(CourtManager) && (
        <>
          <div style={{ marginBottom: 10, marginTop: 12 }}>
            <span style={StyledTitleRoles}>
              {translate(messages.courtManager, props)}
            </span>
          </div>
          <Grid container direction="row" spacing={2}>
            {CourtManager.map((item: any) => renderItem(item))}
          </Grid>
        </>
      )}
      {!isEmpty(CourtMonitoringManager) && (
        <>
          <div style={{ marginBottom: 10, marginTop: 12 }}>
            <span style={StyledTitleRoles}>
              {translate(messages.monitoringManager, props)}
            </span>
          </div>
          <Grid container direction="row" spacing={2}>
            {CourtMonitoringManager.map((item: any) => renderItem(item))}
          </Grid>
        </>
      )}
      {!isEmpty(solhFelHinManager) && (
        <>
          <div style={{ marginBottom: 10, marginTop: 12 }}>
            <span style={StyledTitleRoles}>
              {translate(messages.solhFelHinManager, props)}
            </span>
          </div>
          <Grid container direction="row" spacing={2}>
            {solhFelHinManager.map((item: any) => renderItem(item))}
          </Grid>
        </>
      )}
      {!isEmpty(preOpeningManager) && (
        <>
          <div style={{ marginBottom: 10, marginTop: 12 }}>
            <span style={StyledTitleRoles}>
              {translate(messages.preopenManager, props)}
            </span>
          </div>
          <Grid container direction="row" spacing={2}>
            {preOpeningManager.map((item: any) => renderItem(item))}
          </Grid>
        </>
      )}
      {!isEmpty(transactionManager) && (
        <>
          <div style={{ marginBottom: 10, marginTop: 12 }}>
            <span style={StyledTitleRoles}>
              {translate(messages.transactionManager, props)}
            </span>
          </div>
          <Grid container direction="row" spacing={2}>
            {transactionManager.map((item: any) => renderItem(item))}
          </Grid>
        </>
      )}
      {!isEmpty(isPriorityClaimManager) && (
        <>
          <div style={{ marginBottom: 10, marginTop: 12 }}>
            <span style={StyledTitleRoles}>
              {translate(messages.isPriorityClaimManager, props)}
            </span>
          </div>
          <Grid container direction="row" spacing={2}>
            {isPriorityClaimManager.map((item: any) => renderItem(item))}
          </Grid>
        </>
      )}
      {!isEmpty(otherManagers) && (
        <>
          <div style={{ marginBottom: 10, marginTop: 12 }}>
            <span style={StyledTitleRoles}>
              {translate(messages.otherManagers, props)}
            </span>
          </div>
          <Grid container direction="row" spacing={2}>
            {otherManagers.map((item: any) => renderItem(item))}
          </Grid>
        </>
      )}

      <ConfirmationUnassignedManagerDialog
        confirmationDialog={props.openUnassignedManagerConfirmationDialog}
        handleCloseConfirmationDialog={
          props.handleCloseUnassignedManagerConfirmationDialog
        }
        handleValidate={handleValidate}
      />
    </>
  );
};

export default injectIntl(UnassignedManager);
